/**
 * Theme Toggle Functions
 * Light/dark mode switching with localStorage persistence
 */

import { updateMapTheme } from './map.js';
import { analytics } from './analytics.js';

// Storage keys (new key, with migration from legacy)
const THEME_KEY = 'surf-status-theme';
const LEGACY_THEME_KEY = 'sd-tide-theme';

/**
 * Toggle between light and dark themes
 */
export function toggleTheme() {
    const root = document.documentElement;
    const isLight = root.classList.contains('light-mode');

    if (isLight) {
        root.classList.remove('light-mode');
        localStorage.setItem(THEME_KEY, 'dark');
        updateThemeButton(false);
        updateMapTheme(false);
        analytics.themeToggle('dark');
    } else {
        root.classList.add('light-mode');
        localStorage.setItem(THEME_KEY, 'light');
        updateThemeButton(true);
        updateMapTheme(true);
        analytics.themeToggle('light');
    }

    // Notify listeners (e.g., tide chart) that theme-driven CSS variables changed
    window.dispatchEvent(new CustomEvent('themechange'));
}

/**
 * Update the theme toggle button appearance (icon only)
 */
export function updateThemeButton(isLight) {
    const iconEl = document.getElementById('theme-icon');
    if (!iconEl) return;

    if (isLight) {
        iconEl.textContent = '☀'; // Sun
    } else {
        iconEl.textContent = '☾'; // Moon
    }
}

/**
 * Initialize theme from localStorage or system preference
 * Supports graceful migration from legacy 'sd-tide-theme' key
 */
export function initTheme() {
    // Check new key first, then fall back to legacy key for migration
    let savedTheme = localStorage.getItem(THEME_KEY);

    if (!savedTheme) {
        // Migrate from legacy key if it exists
        const legacyTheme = localStorage.getItem(LEGACY_THEME_KEY);
        if (legacyTheme) {
            savedTheme = legacyTheme;
            // Migrate to new key
            localStorage.setItem(THEME_KEY, legacyTheme);
        }
    }

    // Default to dark mode unless explicitly set to light
    if (savedTheme === 'light') {
        document.documentElement.classList.add('light-mode');
        updateThemeButton(true);
    } else {
        updateThemeButton(false);
    }
}
